module.exports = __webpack_public_path__ + "94c1e85e49a05c07506ea903b38b2a20.pdf";